<template>

	<div class="row mt-5">
	    <div class="col-sm-2"> 
			<select :name="'epSubLabelEditNew['+ epIndexTabContentEdit +'][]'" class="form-control">
				<option v-for="label in tv_captions" :value="label.id">{{ label.label_name }}</option>
			</select>
	    </div>

	    <div class="col-sm-9"> 
	    	<input type="file" :name="'epSubFileEditNew['+ epIndexTabContentEdit +'][]'" :id="'epUploadSubEdit'+ epIndexTabContentEdit + epIndexSubEdit" data-show-preview="false">
	    </div>

	    <div class="col-sm-1">
	    	<button type="button" @click.prevent="epRemoveSubEdit" class="btn btn-danger"><i class="icon-trash"></i></button>
		</div>	
	</div>

</template>

<script>
export default {
  name: 'EpSubAddEdit',
  props: ['epIndexTabContentEdit', 'epIndexSubEdit', 'tv_captions'],
  data () {
    return {
    }
  },
  mounted(){

    let vm = this;

    Ladda.bind('button[type=submit]')

	$("#epUploadSubEdit" + vm.epIndexTabContentEdit + vm.epIndexSubEdit).fileinput({
	    theme: "explorer",
	    browseClass: "btn btn-primary",
		removeClass: "btn btn-danger",
	    showUpload: false,
	    overwriteInitial: false,
	    initialPreviewAsData: false,
	    allowedPreviewTypes: null,
	    allowedFileExtensions: ["srt", "vtt"]
	});

  },
  methods:{
    epRemoveSubEdit() {
        this.$emit('epRemoveSubEdit');
    }
  	//
  }
}
</script>

<style lang="css" scoped>
</style>


// WEBPACK FOOTER //
// src/components/child/EpSubAddEdit.vue